import { Component } from '@angular/core';

@Component({
  selector: 'home-page',
  templateUrl: 'home.html'
})
export class HomePage {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts